import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import "./hm-theme.css";

const AddInvoiceTransaction = ({ isOpen, onRequestClose, invoiceid }) => {
  const navigate = useNavigate();

  const date = new Date();
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;

  const url = "/api/invoiceTransactions/create";

  const [modeOfPayments, setModeOfPayments] = useState([]);
  const [loading, setLoading] = useState(false);

  const [transactions, setTransactions] = useState({
    paymentDate: currentDate,
    modeOfPaymentId: "",
    invoiceId: invoiceid,
    referenceNumber: "",
    amount: "",
    notes: ""
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;
        const res = await axios.get("/api/modeofpayment", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setModeOfPayments(res.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleError(error);
      }
    };
    fetchData();
  }, []);

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    axios.post(url, transactions, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(() => {
      setLoading(false);
      onRequestClose();
      toast.success("Payment details added successfully");
    }).catch((error) => {
      setLoading(false);
      handleError(error);
    });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setTransactions((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">receipt_long</i>
          Add Payment Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label htmlFor="paymentDate" className="form-label small fw-semibold">
                Payment Date <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="paymentDate"
                type="date"
                value={transactions.paymentDate}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="modeOfPaymentId" className="form-label small fw-semibold">
                Mode of Payment <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="modeOfPaymentId"
                value={transactions.modeOfPaymentId}
                onChange={handleChange}
                required
              >
                <option value="">Select Mode</option>
                {modeOfPayments.map((mp) => (
                  <option key={mp.id} value={mp.id}>
                    {mp.paymentType}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label htmlFor="referenceNumber" className="form-label small fw-semibold">
                Reference Number <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="referenceNumber"
                placeholder="TXN Ref / UTR"
                value={transactions.referenceNumber}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="amount" className="form-label small fw-semibold">
                Amount (₹) <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                step="0.01"
                className="form-control"
                id="amount"
                placeholder="0.00"
                value={transactions.amount}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="mb-4">
            <label htmlFor="notes" className="form-label small fw-semibold">Notes</label>
            <textarea
              className="form-control"
              id="notes"
              placeholder="Additional payment notes..."
              rows="2"
              value={transactions.notes}
              onChange={handleChange}
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>payments</i>
              Save Payment
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddInvoiceTransaction;
